import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Button } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import moment from "moment";
import ORDER_STATUS from '../../../../constants/OrderStatus'
import { findDuration, getDateDifference, convertHM } from '../../../../helpers/date.helper'
import Paper from '@material-ui/core/Paper';
import './index.css'


const useStyles = makeStyles((theme) => ({
    paper: {
        height: 140,
        width: 100,
    },
    control: {
        paddingTop: 10,
        // padding: "4%",
        backgroundColor: 'transparent',
        marginBottom: "2%",

    },
    main: {
        paddingTop: '10%', backgroundColor: "rgb(246, 249, 252)", minHeight: "100vh",
        [theme.breakpoints.down("sm")]: {
            paddingTop: '32%',
        },
    }
}));



function HotelOrder(props) {
    const classes = useStyles();


    const { order } = props;


    if (!order)
        return "No Order Data!";
    if (!order.hotel_data)
        return <>Invalid Data</>
    return (
        <div style={{ paddingTop: '2%', paddingLeft: '7%', paddingRight: '7%', backgroundSize: '100px 100px', backgroundPosition: 'bottom 15px right 17px' }}>
            <Grid item xs="12" >
                <Paper className={classes.control} elevation={0}><Grid container spacing={4}>
                    <Grid item xs={2} sm={2} md={2} style={{ textAlign: 'left' }}>
                        <img style={{ borderRadius: '5px' }} src={order?.hotel_data?.Success?.PriceDetails?.HotelList?.[0]?.meta_data?.Images?.[0]?.ImageUrl} alt="" title="" height="53px" class="sc-1go0t46-0 iGlQOH" />
                    </Grid>
                    <Grid item xs={10} sm={10} md={10} style={{ textAlign: 'left' }}>
                        <Grid container>
                            <Grid item xs={6} sm={6} md={6} style={{ textAlign: 'left' }}>
                                <Typography component="p">{order?.hotel_data?.Success?.PriceDetails?.HotelList?.[0]?.meta_data?.Name}</Typography>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} style={{ textAlign: 'left' }}>
                                <Typography component="p">Check In Date: {new Date(order.checkInDate).toLocaleDateString()}</Typography>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} style={{ textAlign: 'left' }}>
                                <Typography component="p">{order?.hotel_data?.Success?.PriceDetails?.HotelList?.[0]?.meta_data?.Address}</Typography>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} style={{ textAlign: 'left' }}>
                                <Typography component="p">Check Out Date: {new Date(order.checkOutDate).toLocaleDateString()}</Typography>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} style={{ textAlign: 'left' }}>
                                <Typography component="p">Amount Paid: {order.currency} <b>{order.order_amount}</b></Typography>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} style={{ textAlign: 'left' }}>
                                <Typography component="p">Status: <b>{order.status}</b></Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs="12" sm="12" style={{ textAlign: "left" }}>
                        <><Grid container style={{ marginBottom: '0px' }}>
                            <Grid item sm="12" md="12"><Typography component="p">Guests</Typography>
                                <table className='table table-sm dense passenger-list-tbl' style={{ color: 'black', fontSize: '14px' }}>
                                    <thead>
                                        <tr>
                                            <td>First Name</td>
                                            <td>Last Name</td>
                                            <td>Room Number</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {order.guestList && order.guestList.length && order.guestList.map((room, i) => {
                                            {
                                                return room.GuestInfo && room.GuestInfo.length && room.GuestInfo.map((guest) => {
                                                    return <tr>
                                                        <td> <Typography component="p">{guest?.Name?.First}</Typography>
                                                        </td>
                                                        <td> <Typography component="p">{guest?.Name?.First}
                                                        </Typography> </td>
                                                        <td> <Typography component="p">{i + 1}</Typography> </td>
                                                    </tr>
                                                })
                                            }
                                        }
                                        )} </tbody>
                                </table></Grid>
                        </Grid>


                        </>

                    </Grid>
                </Grid>
                </Paper>

            </Grid >
        </div >
    )
}
export default HotelOrder;